module.exports = __webpack_public_path__ + "img/knight4_05.0095af21.jpg";